import { Injectable } from "@angular/core";

const ACTION_HISTORY_LENGTH = 30;

@Injectable({ providedIn: "root" })
export class UserActionLogger {

    private userActions: string[] = [];

    logAction(event: string): void {

        this.userActions = [...this.userActions, event]
            .slice(-ACTION_HISTORY_LENGTH);
    }

    getActions(): string[] {

        return this.userActions;
    }
}
